<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import ScrollRow from "../ScrollRow.vue";
import LanguageItem from "./LanguageItem.vue";
import CustomItem from "../CustomItem.vue";
import StarsAnimation from "@/components/StarsAnimation.vue";

const store = useStore();

const addLanguage = (language) =>
  store.dispatch("language/addLanguage", language);

const loading = computed(() => store.state.language.loading);
</script>

<template>
  <section>
    <div class="mb-6 flex flex-col lg:mb-8">
      <p class="mb-4 text-base font-bold text-primary">Language</p>
      <ScrollRow>
        <LanguageItem />
        <div
          v-if="loading"
          class="bg-gray-10 flex flex-col items-center justify-center w-24 h-24 mr-4 rounded-lg cursor-pointer"
        >
          <StarsAnimation :width="96" />
        </div>
        <CustomItem
          v-else
          :itemType="'language'"
          @submit="addLanguage({ language: $event, emoji: '📝' })"
        />
      </ScrollRow>
    </div>
  </section>
</template>
